<template>
  <div class="logo-carousel" ref="root">
    <div class="logo-carousel-wrapper">
      <div class="logo-carousel-list">
        <!-- render slot twice to make the carousel infinite (see transform animation in .scss) -->
        <slot />
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';

const props = defineProps({
  numberOfLogos: {
    type: Number,
  },
});

const root = ref(null);

onMounted(() => {
  if (props.numberOfLogos) {
    const SECONDS_PER_LOGO = 3;
    setMarqueeDurationInSeconds(props.numberOfLogos * SECONDS_PER_LOGO);
  }
});

function setMarqueeDurationInSeconds(seconds) {
  const marqueeDurationName = '--logo-carousel-marquee-duration';
  root.value.style.setProperty(marqueeDurationName, `${seconds}s`);
}
</script>
